import api from 'src/utils/Api'
import { GET_IMAGE } from './Routes'
import { ErrorNotification } from '@components/common/notification'
import IDocumentos from 'src/interfaces/IDocuments'

export const downloadByteArrayAsFile = (
  byteArray: Uint8Array,
  contentType: string
): void => {
  const blob = new Blob([byteArray], { type: contentType })

  const url = URL.createObjectURL(blob)

  window.open(url)
}

export const downloadByteArrayAsZip = (
  byteArray: Uint8Array,
  fileName: string
): void => {
  const url = URL.createObjectURL(
    new Blob([byteArray], { type: 'application/zip' })
  )

  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export const findImageByPath = async (val: IDocumentos, text: string) => {
  try {
    const response = await api.post(GET_IMAGE, val, {
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
    })
    const contentType = response.headers['content-type'] || 'image/png'
    const blob = new Blob([response.data], { type: contentType })
    return URL.createObjectURL(blob)
  } catch (error) {
    ErrorNotification({ message: text })
  }
}

export const openByteArrayNewTab = (
  byteArray: Uint8Array,
  fileName: string
): void => {
  const isPdf =
    byteArray[0] === 0x25 && // %
    byteArray[1] === 0x50 // P

  const type = isPdf ? 'application/pdf' : getContentTypeFromFilename(fileName)

  const blob = new Blob([byteArray], { type })
  const url = URL.createObjectURL(blob)

  const newTab = window.open(url, '_blank')
  if (newTab) newTab.focus()
}

export const getContentTypeFromFilename = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf('.')
  if (lastDotIndex !== -1) {
    const extension = filename.substring(lastDotIndex + 1).toLowerCase()

    switch (extension) {
      case 'pdf':
        return 'application/pdf'
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg'
      case 'png':
        return 'image/png'
      case 'zip':
        return 'application/zip'
      default:
        return 'application/pdf'
    }
  } else {
    return 'application/pdf'
  }
}
